import React, { useEffect, useState } from 'react'
import Api from 'utils/api'
import ButtonGradient from 'component/Buttons/dashboard-btn'
import { formateDate } from 'utils'

function MerchantOverview({ location }) {
  const [plans, setPlans] = useState([])
  const [selectedPlan, setSelectedPlan] = useState(location?.plan_id?._id || '')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    Api('/plans', 'get').then(({ response }) => {
      if (response?.data) setPlans(response.data)
    })
  }, [])

  const handleSavePlan = async () => {
    if (!selectedPlan) return
    setSaving(true)
    await Api('/location/admin/' + location._id, 'put', {
      payload: { plan_id: selectedPlan },
      notify: true,
    })
    setSaving(false)
  }

  const info = [
    { label: 'Business Name',  value: location?.name },
    { label: 'Email',          value: location?.user?.email },
    { label: 'Phone',          value: location?.basic_info?.phone || '—' },
    { label: 'Website',        value: location?.basic_info?.website || '—' },
    { label: 'Country',        value: location?.basic_info?.country || '—' },
    { label: 'Created',        value: formateDate(location?.createdAt) },
    { label: 'API Key',        value: <span className='font-mono text-xs text-gray-400'>{location?.api_key || '—'}</span> },
  ]

  return (
    <div className='max-w-2xl'>
      <div className='bg-white rounded-2xl shadow-sm p-6 mb-4'>
        <h2 className='text-sm font-semibold text-gray-700 mb-4'>Business Information</h2>
        <dl className='grid grid-cols-2 gap-4'>
          {info.map(({ label, value }) => (
            <div key={label}>
              <dt className='text-xs text-gray-400 uppercase tracking-wide'>{label}</dt>
              <dd className='mt-0.5 text-sm text-gray-800 font-medium'>{value || '—'}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className='bg-white rounded-2xl shadow-sm p-6'>
        <h2 className='text-sm font-semibold text-gray-700 mb-4'>Subscription Plan</h2>
        <div className='flex items-center gap-3'>
          <select
            value={selectedPlan}
            onChange={e => setSelectedPlan(e.target.value)}
            className='border border-gray-200 rounded-lg px-3 py-2 text-sm flex-1 focus:outline-none focus:ring-2 focus:ring-blue-200'
          >
            <option value=''>No plan</option>
            {plans.map(p => (
              <option key={p._id} value={p._id}>
                {p.name} — {p.planType === 'monthly' ? 'Monthly' : 'Annual'} (SAR {p.price})
              </option>
            ))}
          </select>
          <ButtonGradient
            type='button'
            onClick={handleSavePlan}
            processing={saving}
            disabled={!selectedPlan}
          >
            Save
          </ButtonGradient>
        </div>
        {location?.plan_id?.name && (
          <p className='text-xs text-gray-400 mt-2'>
            Current plan: <strong>{location.plan_id.name}</strong>
          </p>
        )}
      </div>
    </div>
  )
}

export default MerchantOverview
